// Mock data for Planted Ministries clone
export const site = {
  name: 'Planted Ministries',
  tagline: 'Rooted · Growing · Serving',
  heroImage: 'https://media.base44.com/images/public/6ab1721b8fe909aa01e84e1e/f89ab5777_image.png/v1/fill/w_1920,h_1080,al_c,q_90,enc_webp,quality_auto/f89ab5777_image.webp',
  flyerImage: '/planted-flyer-nov8.jpg',
  flyerDownload: '/planted-flyer-nov8.jpg',
  youtube: 'https://www.youtube.com/@DiscoverGrowServe',
  cashApp: 'https://cash.app/$plantedministries',
  email: 'plantedministries2026@gmail.com',
  tiktok: '@pastorgregwilson',
};

export const nextEvent = {
  id: 'oct25',
  dateLong: 'Sunday, October 25, 2026',
  dateShort: 'Sun, Oct 25',
  dateShortEs: 'Dom, 25 oct',
  time: '10:00 AM',
  venue: 'Schuster Student Success Center · Room 130',
  address: 'Columbus State University · 4107 University Ave, Columbus, GA 31907',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Schuster+Student+Success+Center+Columbus+State+University+4107+University+Ave',
};

// Only future gatherings
export const upcomingEvents = [
  {
    id: 'oct25',
    label: '3rd Meeting',
    labelEs: '3.ª Reuni\u00f3n',
    dateLong: 'Sunday, October 25, 2026',
    dateLongEs: 'Domingo, 25 de octubre de 2026',
    time: '10:00 AM',
    venue: 'Schuster Student Success Center · Room 130',
    venueEs: 'Centro Schuster de \u00c9xito Estudiantil \u00b7 Sala 130',
    address: 'Columbus State University · 4107 University Ave, Columbus, GA 31907',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Schuster+Student+Success+Center+Columbus+State+University+4107+University+Ave',
    // Local time 10:00 America/New_York = 14:00 UTC on 2026-10-25
    startUtc: '20261025T140000Z',
    endUtc: '20261025T160000Z',
  },
];
